// import { Client } from '../clientFlowtypes'

interface State {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: {[key: string]: any};
}

const studiesModule = {
  firestorePath: 'studies',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'studies',
  statePropName: 'data',
  namespaced: true, // automatically added

  // this object is your store module (will be added as '/studies')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    all: (state: State) => state.data,
    getById: (state: State) => (id: string) => state.data[id],
  },
  mutations: {},
  actions: {
  },
}

export default studiesModule
